// Socket.IO is served by the API server, not the static asset host.
export const resolveSocketUrl = (env = process.env, pageUrl = window.location.href) => {
    const page = new URL(pageUrl);
    const isLoopback = hostname => ['localhost', '127.0.0.1', '[::1]'].includes(hostname);
    for (const candidate of [env.REACT_APP_SOCKET_URL, env.REACT_APP_API_URL]) {
        if (!candidate) continue;
        try {
            const url = new URL(candidate, page);
            // Do not ship a developer's local socket address to live visitors.
            if (!isLoopback(page.hostname) && isLoopback(url.hostname)) continue;
            if (page.protocol === 'https:' && url.protocol === 'http:') url.protocol = 'https:';
            if (!['http:', 'https:'].includes(url.protocol)) continue;
            return url.origin;
        } catch { /* Try the API address or the current origin. */ }
    }
    return page.origin;
};
